import React from "react";
import { TextField, Typography, Card, FormControlLabel,Checkbox, Box  } from "@mui/material";

const PriceInput = ({ value, onChange }) => {
  const parsed = typeof value === "string" ? JSON.parse(value || "{}") : value || {};
  const isFree = parsed === null || (parsed["성인"] === 0 && parsed["아동"] === 0);

  const handleChange = (key) => (e) => {
    const updated = {
      ...parsed,
      [key]: Number(e.target.value) || 0,
    };
    onChange(JSON.stringify(updated));
  };
  const handleFreeToggle = (e) => {
    const checked = e.target.checked;
    if (checked) {
      onChange(JSON.stringify({ 성인: 0, 아동: 0 }));
    } else {
      onChange(JSON.stringify({ 성인: "", 아동: "" }));
    }
  };
  return (
    <Card sx={{ display: "flex", flexDirection: "column", gap: 1, p:2 }} variant="outlined">
      <Box sx={{display: "flex", flexDirection: "row", justifyContent:"space-between",alignItems:"center"}}>
        <Typography  sx={{lineHeight:1}}>최대 가격 입력</Typography>
        <FormControlLabel
            control={
            <Checkbox checked={isFree} onChange={handleFreeToggle} />
            }
            label="무료 이용"
        />
      </Box>
      <TextField
        label="성인 요금"
        type="number"
        disabled={isFree}
        value={parsed["성인"] ?? ""}
        onChange={handleChange("성인")}
        InputProps={{ inputProps: { min: 0 } }}
      />
      <Box sx={{pt:1}}></Box>
      <TextField
        label="아동 요금"
        type="number"
        disabled={isFree}
        value={parsed["아동"] ?? ""}
        onChange={handleChange("아동")}
        InputProps={{ inputProps: { min: 0 } }}
      />
    </Card>
  );
};

export default PriceInput;
